import React, { useState, useContext } from 'react';

/* import Bg from  '../../assets/slide4.jpg';*/
import Logo from '../assets/logo.png'; 
import '../styles/register.css';

import * as Constants from '../constants';
import { ShareContext } from '../context/ShareContext'
import { Link, useNavigate, useParams } from 'react-router-dom';
import BackLoader from '../components/backloader'
import DynamicIcon from '../components/dynamicicon';
import JisButton from '../components/controls/jisButton';
import JisDialog from '../components/dialog';

function ResetPassword() {
    const [staySigned, setStaySigned] = useState(false)
    const navigate = useNavigate();
    const { profile , setProfile, setToken} = useContext(ShareContext);
    
  const {resetkey} = useParams(); 
    const [seePass, setSeePass] = useState(false);
    const [err, setErr] = useState('');
    const [loading, setLoading] =useState(false);

    const [login, setLogin]= useState({username:'',password:''});
  const [flowerror, setFlowError]=useState('');
  const [isPass, setIsPass]=useState(true);
  const [sucess_msg, setSucessMsg]= useState('');
  const [isSucess, setIsSuccess] =useState(false);


     const onLoginChange = (e) => {
    setLogin({...login, [e.target.name]: e.target.value})
}
    const onLogin=async(e)=>{
        e.preventDefault(); 
  
          setLoading(true);
          
          try {
        
            const resp = await fetch(`${Constants.apiUrl}/profile/password-reset/${resetkey}`, {
              method: 'POST',
              body:JSON.stringify(login) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
              
               setSucessMsg("Reset completed. Please login");
               setIsSuccess(true);

            }
           else if (data.code == -1) {
              
               setFlowError('The username is not on record');

            }else {   
              setFlowError('The link expired. Please do forget password again');
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
           // onMove();
          }
  
         }

    const GotoLogin=()=>{
        setIsSuccess(false);
        navigate('/login');
        
    }

  return (
    <div class="reg_container">
   <div class="homeside">
        <div style={{flex:1}}>
             <img src={Logo} alt="JIS Logo" className='logo' style={{width:100}}/> 
        </div>
      
       
                <div className="boxx">
                    
                    <p className="text"><div>1. </div> <div> You can register as a Legal Counsel, Non-legal Counsel and also do E-Affidavit.</div></p>
                    <p className="text"> <div>2.</div><div className='dtext'>For Individual and Organisation registration you need a Payer ID.</div> </p>
                    <p className="text"><div>3. </div><div className='dtext'>If you have a Payer ID select the option "I have a Payer ID</div> </p>
                    <p className="text"><div>4. </div><div className='dtext'>If you do not have a Payer ID select the option "I do not have a Payer ID</div> </p>
                    <p className="text"><div>5. </div><div className='dtext'>If you do not have a Payer ID you can generate the Payer ID during the registration process.
                     It is mandatory  to enter the NIN when the fields are displayed.</div> </p>
                    <p className="text"> <div>6.</div><div className='dtext'> Once you are done with the last step, click the "Submit" button
                     to complete the registration process.</div></p>
                </div>
</div>

    <main  class="contentside">
      <div className='success-final'>
         <div className='form-box'>
          <div>
                
      <div  className='content-title'>Reset Password</div>
               </div>
  
      <p class="subtitle">Please provide the username and new password</p>
<div className='success_msg'>{sucess_msg}</div>
      <form onSubmit={onLogin}>
        <div  className="input-group">
            <label> Username</label>
            <div className='input-wrapper'>
                <DynamicIcon iname="person_3" />
                <input  placeholder='Username' required={true} name="username" value={login.username} onChange={onLoginChange}   />
            </div>
        </div>
        <div style={{display:'flex'}}>
                        <div  className="input-group">
                            <label>New Password <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="lock" />
                                <input placeholder='Password' type={`${isPass?'password':'text'}`} name="password" value={login.password} onChange={onLoginChange} required />   
                                 <DynamicIcon iname={`${isPass?'visibility':'visibility_off'}`} onClick={()=> setIsPass(!isPass)} /> 
                            </div>
                        </div>
                        <div  className="input-group">
                            <label> Confirm Password <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="lock" />
                               <input placeholder='Confirm Password 'name="confirmpassword" type={`${isPass?'password':'text'}`} value={login.confirmpassword} onChange={onLoginChange} required />    
                            </div>
                        </div>
                        
                    </div>
        

    {flowerror!='' && <div className='error'>{flowerror}</div> }  

        <div style={{display:'flex', flexDirection:'column'}}>
             <JisButton type='submit'>Set Password</JisButton>
             <div style={{textAlign:'center',margin:20}}>
                <Link to="/">Login</Link>
             </div>   
        </div>
           

      </form>
      </div>
      </div>
     
   
    </main>

  {isSucess && <JisDialog title="Password Reset">
        <div>The password reset is completed.</div>
        <div>
            <JisButton onClick={GotoLogin}>Goto Login</JisButton>
        </div>
    </JisDialog>}  
       {loading &&  <BackLoader />}  
  </div>
  )
}

export default ResetPassword